const clipboard = {
	init() {
		const copyButtons = document.querySelectorAll('[data-clipboard-text]');

		if (!copyButtons.length) return;

		copyButtons.forEach((button) => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				const text = button.getAttribute('data-clipboard-text');
				navigator.clipboard.writeText(text);
			});
		});
	}
}

export default clipboard;
